/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import Card from 'react-bootstrap/Card';
import * as S from './styles';

export interface IBeneficiaryProps {
  title?: string;
  policyHolder: {
    firstName?: string;
    lastName?: string;
    streetAddress?: string;
    country?: string;
    city?: string;
    email?: string;
    telephone?: string;
  };
}
export const BeneficiaryComp = (props: IBeneficiaryProps) => {
  const { title, policyHolder } = props;
  const _renderTitleIf = () => {
    if (title) {
      return <S.Headline>{title}</S.Headline>;
    }
  };

  const _renderBodyIf = () => {
    console.log(`policy holder`, policyHolder);
    if (policyHolder) {
      return (
        <>
          {policyHolder?.firstName ? (
            <S.Text>
              {policyHolder?.firstName} {policyHolder?.lastName}
            </S.Text>
          ) : null}
          {policyHolder?.streetAddress ? (
            <S.Text>{policyHolder?.streetAddress}</S.Text>
          ) : null}
          {policyHolder?.country ? (
            <S.Text>
              {policyHolder?.city}, {policyHolder?.country}
            </S.Text>
          ) : null}
          {policyHolder?.email ? (
            <S.Text>
              {policyHolder?.email}, {policyHolder?.telephone}
            </S.Text>
          ) : null}
        </>
      );
    }
  };
  return (
    <Card border="0" className="shadow pt-3 pb-3">
      <Card.Body className="py-0">
        {_renderTitleIf()}
        {_renderBodyIf()}
      </Card.Body>
    </Card>
  );
};

BeneficiaryComp.defaultProps = {
  title: 'Policy Holder',
  policyHolder: {
    fullName: 'John Doe',
    streetAddress: 'Castle Bruce,Dominica',
    country: 'Dominica',
    city: 'La Romana',
    email: 'john.doe@gmail.com',
    telephone: '+1656767897',
  },
};
